module.exports = __webpack_public_path__ + "img/9177fd3.png";